export * from "@workspace/gamja-platform/components/ProblemContentRenderer";
export { default } from "@workspace/gamja-platform/components/ProblemContentRenderer";
